import React from 'react';

const CategoryContext = React.createContext({
  categories: [],
  categoriesFlat: [],
  updateCategories: () => {},
});

export default CategoryContext;
